"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function ClientLogos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const clientLogos = [{
    id: 1,
    name: "Tech Corp",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_tech_corp.png"
  }, {
    id: 2,
    name: "Global Solutions",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_global_solutions.png"
  }, {
    id: 3,
    name: "Innovate Labs",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_innovate_labs.png"
  }, {
    id: 4,
    name: "Digital Dynamics",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_digital_dynamics.png"
  }, {
    id: 5,
    name: "Future Systems",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_future_systems.png"
  }, {
    id: 6,
    name: "Prime Technologies",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_prime_technologies.png"
  }, {
    id: 7,
    name: "Nexus Group",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_nexus_group.png"
  }, {
    id: 8,
    name: "Apex Innovations",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_apex_innovations.png"
  }, {
    id: 9,
    name: "Vertex Partners",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_vertex_partners.png"
  }, {
    id: 10,
    name: "Quantum Enterprises",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_quantum_enterprises.png"
  }, {
    id: 11,
    name: "Stellar Networks",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_stellar_networks.png"
  }, {
    id: 12,
    name: "Zenith Corporation",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/client_zenith_corporation.png"
  }];
  return;
}